import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=064aabb9&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=064aabb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064aabb9",
  null
  
)

export default component.exports